import { QueryKey } from '@tanstack/react-query'

export const QueryKeys = {
  CONFIGURATION: ['configuration'] as QueryKey,
  USERS: ['users'] as QueryKey,
  BOOKINGS: ['bookings'] as QueryKey,
  SPOT_AVAILABILITY_LOCKS: ['spotAvailabilityLocks'] as QueryKey,
  COMPLETED_BOOKINGS: ['completedBookings'] as QueryKey,
  DAILY_ANALYTICS: ['dailyAnalytics'] as QueryKey,
  CUSTOMER_ANALYTICS: ['customerAnalytics'] as QueryKey,
} as const
